import {
  Add_Lead_Assigned_Type,
  Delete_Lead_Assigned_Type,
  Get_All_Lead_Assigned_Type,
  Get_All_Leads_Selected_TO_Assign_Type,
  Get_Error,
  Get_One_Lead_Assigned_Type,
  Update_One_Lead_Assigned_Type,
} from '../Types';

const intial = {
  Lead_Assigned: [],
  Lead_Selected_To_Assigned: [],
  loading: true,
};
export const Lead_Assigned_Reducers = (state = intial, action) => {
  switch (action.type) {
    case Add_Lead_Assigned_Type:
      return {
        Lead_Assigned: action.payload,
        loading: false,
      };
    case Get_All_Lead_Assigned_Type:
      return {
        ...state,
        Lead_Assigned: action.payload,
        loading: false,
      };
    case Update_One_Lead_Assigned_Type:
      return {
        ...state,
        Lead_Assigned: action.payload,
        loading: false,
      };
    case Delete_Lead_Assigned_Type:
      return {
        ...state,
        Lead_Assigned: action.payload,
        loading: false,
      };
    case Get_One_Lead_Assigned_Type:
      return {
        ...state,
        Lead_Assigned: action.payload,
        loading: false,
      };
    case Get_All_Leads_Selected_TO_Assign_Type:
      return {
        ...state,
        Lead_Selected_To_Assigned: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        Developers: action.payload,
      };
    default:
      return state;
  }
};
